// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend) // Charge les traductions via le backend
  .use(LanguageDetector) // Détecte la langue de l'utilisateur
  .use(initReactI18next) // Passe l'instance i18n à react-i18next
  .init({
    fallbackLng: 'en', // Langue par défaut
    debug: false,
    interpolation: {
      escapeValue: false, // React gère déjà l'échappement XSS
    },
    backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json', // Correct path
     },
     
     detection: {
        order: ['navigator', 'queryString', 'cookie'],
        caches: ['cookie'],
        // Add this for logging the detected language
        lookupQueryString: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
     },
     
     
  });

export default i18n;
